export const templatesApi = {
  async fetchTemplate(path: string): Promise<string> {
    const response = await fetch(path);
    if (!response.ok) throw new Error(`Failed to fetch template: ${response.statusText}`);
    return response.text();
  },

  fetchPowerQueryTemplate(): Promise<string> {
    return this.fetchTemplate('/export/examples/powerQuery_export_script_template.txt');
  },

  fetchPythonTemplate(): Promise<string> {
    return this.fetchTemplate('/export/examples/python_export_script_template.txt');
  }
};
